<template>
  <ion-page>
    <!--simulate iontoolbar margin/padding stuff-->
    <div class="content-gap"></div>
    <!--:style="{height: isIos ? '100px' : '50px'}"-->

    <ion-progress-bar  type="indeterminate" v-if="syncActive && currentProgress == 0"></ion-progress-bar>
    <ion-progress-bar color="primary" v-if="syncActive && currentProgress > 0"
                      :value="currentProgress"></ion-progress-bar>

    <small class="ion-padding checking-data" v-if="syncActive && downloadSize === 0">{{ wordings[currentLanguage].CHECKING_DATA }}</small>
    <small class="ion-padding checking-data" v-if="syncActive && downloadSize && downloadLabel">{{ downloadLabelText }}
      {{ downloadSize }} {{ downloadLabel }} - {{ (currentProgress * 100).toFixed(2) }}%</small>

    <banner direction="horizontal" position="top"></banner>

    <slot></slot>
    <banner   direction="vertical" position="bottom"></banner>
    <ion-footer >
   <div class="bottom-navigation-bar menu-color">
   
 <button class="bottom-nav-button" @click="goToProgramme()">
      <ion-icon class="menu-conference" :name="programmeIconName()"></ion-icon>
      <span class="bottom-nav-label menu-conference">Program</span>
    </button>
    <button class="bottom-nav-button" @click="goToHome()"> 
      <ion-icon class="menu-conference" :name="homeIconName()"></ion-icon>
      <span class="bottom-nav-label menu-conference">Home</span>
    </button>
 <button class="bottom-nav-button" @click="goToChat()"> 
      <ion-icon class="menu-conference" :name="chatIconName()"></ion-icon>
      <span class="bottom-nav-label menu-conference">Chat & Networking</span>
      <span v-if="unreadTotal > 0" class="bottom-nav-badge">{{ unreadTotal }}</span>
    </button>
   
  </div>
    </ion-footer>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonFooter,
  IonToolbar,
  IonProgressBar,
  alertController
} from "@ionic/vue";

import {defineComponent} from "vue";
import {mapState, mapGetters} from "vuex";
import {isPlatform, modalController} from '@ionic/vue';
import PdfModal from "@/views/Industry/PdfModal";

const config = require('@/config')
import {addIcons} from "ionicons";
import {
  personCircleOutline, 
  logoRss, 
  chatbubbleOutline,
  chatbubble,
  logInOutline,
  logOutOutline,
  bookmarksOutline,
  bookmark,
  peopleOutline,
  people,
  calendar,
  calendarOutline,
  home,
  homeOutline
} from "ionicons/icons";

addIcons({
  "person-circle-outline": personCircleOutline,
  "logo-rss": logoRss,
  "chatbubble-outline": chatbubbleOutline,
  "chatbubble": chatbubble,
  "log-in-outline": logInOutline,
  "log-out-outline": logOutOutline,
  "bookmark-outline": bookmarksOutline,
  "bookmark": bookmark,
  "people-outline": peopleOutline,
  "people": people,
  "calendar": calendar,
  "calendar-outline": calendarOutline,
  "home": home,
  "home-outline": homeOutline
});

export default defineComponent({
  name: "App",
  components: {
    IonPage,
    IonFooter,
    IonToolbar,
    IonProgressBar,
  },
  data() {
    return {

      isDesktop: null,
      isIos:null,
      title: config.full_name,
      
    }
  },
  mounted() {
  },
  methods: {


    async handleFile() {
      let link = ""
      let viewerLink =  link
      console.log(viewerLink)

      this.modal = await modalController
          .create({
            component: PdfModal,
            cssClass: 'pdf-modal',
            componentProps: {
              title: "Privacy policy",
              link: viewerLink
            },
          })
      return this.modal.present();
    },


  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress','downloadLabelText']),
     ...mapState('wordings',['wordings', 'currentLanguage']),
  },
  async created() {
    this.isDesktop = isPlatform('desktop');
    this.isIos = isPlatform('ios')
  },

   watch: {
    '$route': {
      immediate: true,
      async handler() {

       
      }
    }
  },

  methods: {

     // Computed properties for active bottom nav icons
    chatIconName() {
      return this.$route.path === '/app/chat/' ? 'chatbubble' : 'chatbubble-outline';
    },
    
    favoritesIconName() {
      const activePaths = [
        '/app/favorites/',
      ];
      return activePaths.includes(this.$route.path) ? 'bookmark' : 'bookmark-outline';
    },

    homeIconName() {
      return this.$route.path === '/app/dashboard' ? 'home' : 'home-outline';
    },
    
    programmeIconName() {
         const activePaths = [
        '/app/sessionlist',
        '/app/sessiontypes',
        '/app/sessiontypes/da7ad0c0-3ed1-4500-1582-0b0000000018',
        '/app/dashboard/ed3775b7-970f-479c-9ccd-160e20ab5837'
      ];
       return  activePaths.includes(this.$route.path)? 'calendar' : 'calendar-outline';
    },

    goToNews() {
            this.$router.push('/app/posts/');
    },

    goToChat() {
      if (this.user && this.user.id) {
        this.$router.push('/app/chat/');
      } else {
        this.chatAlert()
      }
    },


    goToFavorites() {
      // Dummy link for Events
       this.$router.push('/app/favorites/');
      // You can replace this with: this.$router.push('/app/events/');
    },

    goToHome() {
      this.$router.push('/app/dashboard');
    },

    goToProgramme() {
      // Dummy link for Network
       this.$router.push('/app/sessionlist');
      // You can replace this with: this.$router.push('/app/network/');
    },

     async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: this.wordings[this.currentLanguage].LOGIN_REQUIRED,
            message: this.wordings[this.currentLanguage].LOG_IN_QUESTION,
            buttons: [
              {
                text: this.wordings[this.currentLanguage].NO_ANSWER,
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: this.wordings[this.currentLanguage].YES_ANSWER,
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },
      async login() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });

        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
          redirect(link.toString());
        }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });


      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }
    },
  }





});
</script>
<style lang="scss">

.docu-footer {
  background: white !important;
  border-top: 1px solid lightgrey;

  .footer-container {
    width: 100%;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center; //center
    padding-right: 10px;



    .footer-link {
      color: #274564 !important;
      margin: 1px 5px 2px 5px;
      font-weight: 400;
      font-size: 0.9rem;
      text-decoration: none;
    }
  }

}

 ion-progress-bar {
    --background: #274564 ;
    --buffer-background: #274564 ;
  }


/* Bottom Navigation Bar Styles */
.bottom-navigation-bar {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 0 10px;
}

.bottom-nav-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  padding: 5px;
  transition: all 0.3s ease;
}

.bottom-nav-button:hover {
  transform: scale(1.05);
}

.bottom-nav-button:active {
  transform: scale(0.95);
}

.bottom-nav-button ion-icon {
  font-size: 24px;
  margin-bottom: 2px;
}

.bottom-nav-label {
  font-size: 11px;
  font-weight: 500;
  margin-top: 2px;
}

.bottom-nav-badge {
  position: absolute;
  top: 2px;
  right: calc(50% - 20px);
  background: #ff3b30;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: bold;
  min-width: 18px;
  text-align: center;
}


</style>
